<template>
  <div
    ref="containerRef"
    class="landing-page__custom-html"
    :style="`background: ${section?.backgroundColor || '#ffffff'}`"
    @click="handleClick"
  >
    <div v-if="section.html" v-html="section.html"></div>
    <sib-skeleton-loading
      v-else
      height="1em"
      width="60%"
    ></sib-skeleton-loading>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { CustomHtmlType } from '@/types'

withDefaults(defineProps<{ section: any }>(), {})

const containerRef = ref<HTMLElement | null>(null)

function copyToClipboard(text: string): Promise<void> {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text).catch(() => fallbackCopy(text))
  }
  return fallbackCopy(text)
}

function fallbackCopy(text: string): Promise<void> {
  return new Promise((resolve, reject) => {
    try {
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      const successful = document.execCommand('copy')
      document.body.removeChild(textArea)
      if (successful) resolve()
      else reject(new Error('execCommand failed'))
    } catch (err) {
      reject(err)
    }
  })
}

function executeCopy(target: HTMLElement) {
  const copyBtn = target.closest('.btn-copy, [data-copy-coupon]') as HTMLElement | null
  if (!copyBtn) return

  const root = copyBtn.closest('.promo-bogo-container, .landing-page__custom-html') || document
  const codeEl = root.querySelector('.coupon-code, #couponCode') as HTMLElement | null
  const code = copyBtn.dataset.coupon || codeEl?.innerText?.trim() || 'BOGO'

  copyToClipboard(code)
    .then(() => {
      const textEl = copyBtn.querySelector('.copy-text, span') as HTMLElement | null
      const originalText = textEl ? textEl.innerText : copyBtn.innerText

      if (textEl) {
        textEl.innerText = 'Copied!'
      } else {
        copyBtn.innerText = 'Copied!'
      }

      setTimeout(() => {
        if (textEl) {
          textEl.innerText = originalText
        } else {
          copyBtn.innerText = originalText
        }
      }, 2000)
    })
    .catch((err) => {
      console.error('Failed to copy coupon:', err)
    })
}

function handleClick(event: MouseEvent) {
  executeCopy(event.target as HTMLElement)
}

let isGlobalListenerAdded = false

function handleGlobalClick(event: MouseEvent) {
  const target = event.target as HTMLElement
  if (target.closest('.btn-copy, [data-copy-coupon]')) {
    executeCopy(target)
  }
}

onMounted(() => {
  // Chỉ đăng ký sự kiện global khi trong section HTML thực sự có tồn tại nút copy
  const hasCopyButton = containerRef.value?.querySelector('.btn-copy, [data-copy-coupon]')
  if (hasCopyButton) {
    document.addEventListener('click', handleGlobalClick)
    isGlobalListenerAdded = true
  }
})

onUnmounted(() => {
  if (isGlobalListenerAdded) {
    document.removeEventListener('click', handleGlobalClick)
  }
})
</script>
